"use client";

import Markdown from "@/utils/Markdown";

import Image from "next/image";
import Link from "next/link";


export default function ServicesRealCards(cluster: any) {
  // console.log("cluster", cluster);

  return (
    <>
      <section className="cu-container mx-auto  bg-gray m-[20px] relative mb-20 p-16">
        <div className="traingle border-t-[#fff] border-t-[30px] border-l-[45px] border-r-[45px] left-[10%]"></div>
        <div className="title mb-8">
          <h3 className="text-center pb-4">
            <Markdown>{cluster?.title}</Markdown>
          </h3>
          <div className="text-center bdy-txt-5">
            <Markdown cls="bdy-txt-5 text-center">{cluster?.text}</Markdown>
          </div>
        </div>
        <div className="grid grid-cols-3 gap-8">
          {cluster?.cards?.map((item: any, index: number) => (
            <div
              key={index}
              className="col-span-3 lg:col-span-1 mb-8 md:mb-0 mx-auto"
            >
              <div
                className={`card  md:w-[360px] md:h-[200px] h-[150px] rounded-[10px] relative pl-4 py-4 
                  ${item?.background === "GRADIENT"
                    ? "gradient-bg"
                    : item?.background === "RED"
                      ? "bg-red"
                      : item?.background === "BLACK"
                        ? "bg-black"
                        : ""
                  }`}
              >
                <p className="top-0 text-white bdy-txt-1">{item?.name}</p>
                <h5 className="bottom-0 absolute text-white">${item?.priceValue}<span className="bdy-txt-4 text-white">/{item?.priceOccurance}</span></h5>
              </div>
              <div className="md:w-[360px]">
                <div className="intro mt-6 bdy-txt-1 text-[20px]">
                  <Markdown>{item?.description}</Markdown>
                </div>
                {item?.list?.map((listItem: any, index: number) => (
                  <div className="list flex flex-row items-baseline mt-6 bdy-txt-1 text-[20px]" key={index}>
                    <Image
                      src="/assets/icons/check.svg"
                      alt="Logo"
                      width={20}
                      height={50}
                      className="mr-2"
                    />
                    <Markdown>{listItem?.text}</Markdown>
                  </div>
                ))}
              </div>


            </div>
          ))}
        </div>
        <div className="flex flex-col md:flex-row justify-center gap-6">
          {cluster?.facts?.map((item: any, index: number) => (
            <div key={index} className="list flex flex-row items-baseline mr-8">
              <Image
                src="/assets/icons/check.svg"
                alt="Logo"
                width={20}
                height={50}
                className="mr-2"
              />
              <div className="flex flex-col bdy-txt-1 text-[30px] mt-12">
                <Markdown>{item?.text}</Markdown>
              </div>
            </div>
          ))}
        </div>
        <div className="flex justify-center my-12 pb-16 md:pb-0">
          <Link href={cluster?.cta?.link} className="over:border-b-0">
            <button className="btn-primary w-[400px]">{cluster?.cta?.text}</button>
          </Link>
        </div>
      </section>
    </>
  );
}
